import { Util } from "@base/util/Util";
import { IArticle } from "@biz/definitions/ArticleDefinitions";
import { CornerType, SunSailType } from "@biz/definitions/SunSailDefinitions";
import { IClothArticleId } from "@biz/logic/ClothData";
import { clothGroups, clothInfos } from "@biz/SunSailColors";

export class ArticleLogic {
  static getDefaultMaterialUsageWidth(articleId: string, params: { isStyle: boolean; isSpecialColor: boolean; }): number | undefined {
    const clothArticleId = ArticleLogic.getClothArticleId(articleId);
    if (!clothArticleId) {
      return undefined;
    }
    const group = clothArticleId.group;
    const defaultRollWidth = clothInfos[group].defaultMaterialUsageWidth
    if (Util.isFunction(defaultRollWidth)) {
      return defaultRollWidth(params);
    }
    return defaultRollWidth;
  }
  static isClothArticle(articleNumber: string, articleMap?: Record<string, IArticle>): boolean {
    const article = articleMap?.[articleNumber];
    return ArticleLogic.isClothArticleWithBeos(articleNumber, article);
  }

  static isClothArticleWithBeos(articleNumber: string, beosArticle?: IArticle): boolean {
    const clothArticleId = ArticleLogic.getClothArticleId(articleNumber);
    if (beosArticle) {
      const isClothArticleNew = !!beosArticle.colorGroup;
      if (isClothArticleNew !== !!clothArticleId) {
        console.warn("ClothArticleNew !== ClothArticle Old!!!", articleNumber);
      }
      return !!clothArticleId;
    }
    return !!clothArticleId;
  }

  // static getClothType(articleNumber: string): ClothType {
  //   const clothArticleId = ArticleLogic.getClothArticleId(articleNumber);
  //   if (!clothArticleId)
  //     return ClothType.None;
  //   return clothInfos[clothArticleId.group]?.clothType || ClothType.None;
  // }

  static getClothArticleId(articleNumber: string): IClothArticleId | undefined {
    const systems: string[] = [
      "54", // Outdoor
      "60", // Fixed
      "612", // Standard
      "50", // Sandy
      "70", // Soliday M
      "71", // Soliday C
      "72", // Soliday CS
      "73", // Soliday A
      "74", // Soliday X
      "75", // Raff M
      "76", // Soliday XS
      "77", // One
      "78", // One
      "79", // Flex
      "82", // Flex Diy
      "RLVZ", // Reload
      "UP", // Unplugged
      "CO", // Chillout
      "6B0779", // SoJo
      "6B0879", // SoJo
      "6B1879", // SoJo
    ]

    for (const system of systems) {
      if (articleNumber.startsWith(system)) {
        const sub = articleNumber.substring(system.length);
        for (const group of clothGroups) {
          if (sub.startsWith(group)) {
            return {
              system,
              group,
              type: sub.substring(group.length)
            }
          }
        }
      }
    }
    return undefined;
  }

  static isCornerForAll(sunSailType: SunSailType, ct: CornerType | undefined): boolean {
    if (sunSailType === SunSailType.Standard) return true;
    return ct === CornerType.OrcaRing || ct === CornerType.O_Ring || ct === CornerType.RoundPlate /*old orca */ || ct === CornerType.OrcaPlate || ct === CornerType.ChillSail;
  }
}